module.exports = __webpack_public_path__ + "static/media/officeImg3.b08cc23d.png";